// extracted by mini-css-extract-plugin
module.exports = {"border":"AssetFormItem_border__1rz1n","header":"AssetFormItem_header__3213k","error":"AssetFormItem_error__VDMjO","input":"AssetFormItem_input__10HxP"};